
import LiveShareService from './liveshare';

export default {
  name: 'LiveShareService',
  create: ({ configuration = {} }) => {
    return LiveShareService;
  },
}
